import Banner from "../../../sections/common/banner";
import SectionClients2 from "../../../sections/home/index2/section-clients2";
import { NavLink } from "react-router-dom";
import ItodoImage from "../../../elements/itodo-img";
import { bannerData } from "../../../../globals/banner";
import { caseStudies } from "../../../../globals/neuron-content";

function OperationsListPage() {
  return (
    <>
      <Banner _data={bannerData.operations} />
      <div className="section-full p-t100 p-b70 sx-bg-light mobile-page-padding">
        <div className="container">
          <div className="section-content">
            <div className="large-title-block">
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="section-head left">
                    <div className="sx-head-s-title">Our Operations</div>
                    <div className="sx-head-l-title"><h2 className="sx-title">Security deployment cases</h2></div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6"><div className="large-title-info"><p>Examples of how we secure movement, assets and project environments under varying risk conditions.</p></div></div>
              </div>
            </div>

            <div className="masonry-outer mfp-gallery news-grid clearfix row">
              {caseStudies.map((item) => {
                const detailPath = `/operations/${item.slug}`;
                return (
                  <div key={item.slug} className="masonry-item col-lg-6 col-md-6 col-sm-12 m-b30">
                    <div className="sx-case-study-bx sx-overlay-effect">
                      <div className="sx-case-media sx-img-overlay">
                        <NavLink to={detailPath}><ItodoImage src={item.image} alt={item.title} /></NavLink>
                        <NavLink to={detailPath} className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink>
                      </div>
                      <div className="sx-case-info">
                        <div className="sx-s-title">{item.category}</div>
                        <NavLink className="sx-l-title" to={detailPath}><h2 className="sx-title">{item.title}</h2></NavLink>
                        <div className="sx-case-readmore"><NavLink to={detailPath} title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa fa-long-arrow-right" />Read More</NavLink></div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
      <SectionClients2 />
    </>
  );
}

export default OperationsListPage;
